import React from "react";
import { profile, stats } from "../../mock";
import { ArrowDownRight, MapPin } from "lucide-react";

const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="top"
      className="relative pt-36 md:pt-44 pb-24 md:pb-32 px-6 md:px-10 overflow-hidden"
    >
      {/* subtle decorative grid */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.035] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(#1F1B16 1px, transparent 1px), linear-gradient(90deg, #1F1B16 1px, transparent 1px)",
          backgroundSize: "56px 56px",
        }}
      />

      <div className="max-w-6xl mx-auto relative">
        <div className="flex items-center gap-3 mb-8">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#B8542B] opacity-60" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-[#B8542B]" />
          </span>
          <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#6B5F52]">
            {profile.availability}
          </span>
        </div>

        <h1 className="font-serif text-[#1F1B16] text-[44px] sm:text-6xl md:text-7xl lg:text-[88px] leading-[1.02] tracking-tight">
          {profile.firstName}
          <br />
          <span className="italic text-[#8a5a3d]">{profile.lastName}.</span>
        </h1>

        <div className="mt-10 grid md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-7">
            <p className="text-[#3a342d] text-lg md:text-xl leading-relaxed max-w-xl">
              {profile.tagline}
            </p>
            <p className="mt-5 text-[#6B5F52] text-base leading-relaxed max-w-xl">
              {profile.longTagline}
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <button
                onClick={() => scrollTo("projects")}
                className="group inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#1F1B16] text-[#FAF7F2] hover:bg-[#2c261f] transition-colors duration-300"
              >
                See selected work
                <ArrowDownRight
                  size={18}
                  className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:translate-y-0.5"
                />
              </button>
              <button
                onClick={() => scrollTo("contact")}
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-[#1F1B16]/20 text-[#1F1B16] hover:border-[#1F1B16] transition-colors duration-300"
              >
                Get in touch
              </button>
            </div>
          </div>

          <div className="md:col-span-5 md:pl-8 md:border-l md:border-[#E8E0D3]">
            <div className="flex items-center gap-2 text-[#6B5F52] text-sm mb-6">
              <MapPin size={14} />
              <span className="font-mono text-[11px] uppercase tracking-[0.18em]">
                {profile.location}
              </span>
            </div>
            <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-[#8a7d6e] mb-3">
              Currently / Role
            </div>
            <div className="font-serif text-2xl text-[#1F1B16] leading-tight">
              {profile.role}
            </div>

            <div className="mt-10 grid grid-cols-2 gap-x-6 gap-y-8">
              {stats.map((s) => (
                <div key={s.label}>
                  <div className="font-serif text-3xl md:text-4xl text-[#1F1B16] leading-none">
                    {s.value}
                  </div>
                  <div className="mt-2 text-[12px] text-[#6B5F52] leading-snug">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
